import { render, staticRenderFns } from "./Notifications_History.vue?vue&type=template&id=67fa9d87&scoped=true&"
import script from "./Notifications_History.vue?vue&type=script&lang=js&"
export * from "./Notifications_History.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_History.vue?vue&type=style&index=0&id=67fa9d87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa9d87",
  null
  
)

export default component.exports